import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const ShClockIcon = ({ height = 16 }) => (
  <ImageIcon src={Images.Clock} alt="empty-data/" height={height} />
);

export default ShClockIcon;
